import type { JssStyle } from 'jss';
import type { WebWidgetModel } from '@web/types';
import { type GalleryWidgetData } from '@web/widgets/gallery/type/gallery-widget.type';

import { EGalleryTypes, EHorizontalPosition, Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';

import { GalleryViewComponent } from '@web/widgets/gallery/components/gallery-view/gallery-view.component';
import { GalleryControlComponent } from '@web/widgets/gallery/components/gallery-control/gallery-control.component';
import { gridOptions } from '@web/widgets/gallery/model/defaultOptions';

// DEFAULT COMPONENT SETTINGS
const galleryData: GalleryWidgetData = {
    type: EGalleryTypes.grid,
    options: gridOptions,
    images: [],
    horizontalAlign: EHorizontalPosition.L,
    maxWidth: null,
    resizedHeight: null,
    hideOnMobile: false,
    hideOnTablet: false,
    hideOnDesktop: false,
    isSynchronizeStyle: true,
    position: {
        width: 100,
        x: 0,
        y: 0,
        rotate: 0,
        zIndex: 0,
        mobileX: 0,
        mobileY: 0,
        mobileRotate: 0,
        mobileZIndex: 0,
    },
};

const galleryStyle: JssStyle = {};

export const galleryWidgetModel: WebWidgetModel = {
    componentView: GalleryViewComponent,
    componentControl: GalleryControlComponent,
    name: Widgets.GALLERY,
    label: 'widget_gallery_label',
    data: galleryData,
    styles: galleryStyle,
    permission: defaultWidgetPermission,
    params: defaultWidgetParams,
};
